import generateActions from 'utils/actions';

export const GET_FAVORITE_SONGS = generateActions('playlists/GET_FAVORITE_SONGS');
export const GET_HISTORY = generateActions('playlists/GET_HISTORY');
export const GET_PLAYLIST = generateActions('playlists/GET_PLAYLIST');
export const DELETE_PLAYLIST_SONG = generateActions('playlists/DELETE_PLAYLIST_SONG');
export const DELETE_HISTORY = generateActions('playlists/DELETE_HISTORY');
export const DELETE_HISTORY_SONG = generateActions('playlists/DELETE_HISTORY_SONG');
export const REMOVE_FAVORITE_SONG = 'playlists/REMOVE_FAVORITE_SONG';
export const TOGGLE_FAVORITE_SONG = 'playlists/TOGGLE_FAVORITE_SONG';

/**
 * Get the playlist details with all songs
 * @param {String} playlistId 
 */
export function getPlaylist(playlistId) {
  return {
    types: GET_PLAYLIST,
    promise: {
      url: `/playlists/${playlistId}/public`,
    },
  };
}

export function deletePlaylistSong(playlist, song) {
  return {
    types: DELETE_PLAYLIST_SONG,
    promise: {
      url: `/playlists/${playlist.id}/song/${song.id}`,
      method: 'DELETE',
    },
    data: {
      playlist,
      song,
    }
  };
}

/**
 * Get favorite songs
 */
export function getFavoriteSongs() {
  return {
    types: GET_FAVORITE_SONGS,
    promise: {
      url: '/playlists/favorites',
    },
  };
}

/**
 * Removes a favorite from song from favorites array
 * @param {Song} song 
 */
export function removeFavoriteSong(song) {
  return {
    type: REMOVE_FAVORITE_SONG,
    payload: {
      song,
    }
  }
}

/**
 * Toggles the favorite field on a given song for a given playlist
 * @param {Song} song 
 * @param {String} playlist history | current | favorites
 */
export function toggleFavoriteSong(song, playlist) {
  const valid = ['history', 'current', 'favorites'];

  if (!valid.includes(playlist)) {
    throw Error(`The playlist ${playlist} is not valid, it should be one of ${valid}`);
  }

  return {
    type: TOGGLE_FAVORITE_SONG,
    payload: {
      song,
      playlist,
    }
  }
}

/**
 * Get history for the current user
 */
export function getMyHistory(page = 0) {
  return {
    types: GET_HISTORY,
    promise: {
      url: `/playlists/history`,
      data: {
        page,
      }
    },
  };
}

/**
 * Clear all history for the curren user
 */
export function deleteHistory() {
  return {
    types: DELETE_HISTORY,
    promise: {
      url: '/playlists/history',
      method: 'DELETE',
    }
  };
}

/**
 * 
 * @param {Song} song 
 */
export function deleteHistorySong(song) {
  return {
    types: DELETE_HISTORY_SONG,
    promise: {
      url: `/playlists/history/${song.activityId}`,
      method: 'DELETE',
    },
  };
}
